<form [formGroup]="form" class="position-relative">
  <mat-form-field class="custom-mat-form-field form-field">
    <input matInput formControlName="value" autocomplete="off" (ngModelChange)="changeValueInput($event)">
    <mat-label class="custom-mat-label">{{name}}
      <span class="custom-mat-label_capitalize">
      ( {{ 'customer_type.individual.form.label.fill_in_full' | translate }} {{name}} {{ 'customer_type.individual.form.label.and_click_icon_to_add' | translate }} )
      </span>
    </mat-label>
  </mat-form-field>
  <button mat-button class="add-new"
    [disabled]="!form.dirty || form.get('value').value === ''"
    [class.disabled]="!form.dirty || form.get('value').value === ''"
    (click)="addNewRecord()">
    <img class="themified-white-icon" src="/assets/icons/plus-icon-white.png">
  </button>
</form>
<div class="table-and-paginator-container" *ngIf="values?.length">
  <div class="table-container">
    <table mat-table class="custom-mat-table" [dataSource]="dataSource">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{name}}</th>
        <td mat-cell *matCellDef="let item" class="">{{item}}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="table__header_action"> {{ 'general.table.label.actions' | translate }} </th>
        <td mat-cell *matCellDef="let item" class="table__cell_action">
          <div class="table__actions-container">
            <img class="themified-white-icon table__action-icon" src="/assets/icons/edit-icon.png" title="Edit" (click)="editValue(item)">
            <img class="themified-white-icon table__action-icon" src="/assets/icons/minus-icon-white.png" title="Delete" (click)="deleteValue(item)">
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <mat-paginator class="custom-mat-paginator" [pageSizeOptions]="[2, 5, 10]" showFirstLastButtons></mat-paginator>
</div>
